var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSquare({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 12H8.33333C8.79167 12 9.16667 11.625 9.16667 11.1667V5.83333C9.16667 5.375 8.79167 5 8.33333 5H5.83333C5.375 5 5 5.375 5 5.83333V11.1667C5 11.625 5.375 12 5.83333 12ZM5.83333 19.8333H8.33333C8.79167 19.8333 9.16667 19.4583 9.16667 19V13.6667C9.16667 13.2083 8.79167 12.8333 8.33333 12.8333H5.83333C5.375 12.8333 5 13.2083 5 13.6667V19C5 19.4583 5.375 19.8333 5.83333 19.8333ZM10.8333 19.8333H13.3333C13.7917 19.8333 14.1667 19.4583 14.1667 19V13.6667C14.1667 13.2083 13.7917 12.8333 13.3333 12.8333H10.8333C10.375 12.8333 10 13.2083 10 13.6667V19C10 19.4583 10.375 19.8333 10.8333 19.8333ZM15.8333 19.8333H18.3333C18.7917 19.8333 19.1667 19.4583 19.1667 19V13.6667C19.1667 13.2083 18.7917 12.8333 18.3333 12.8333H15.8333C15.375 12.8333 15 13.2083 15 13.6667V19C15 19.4583 15.375 19.8333 15.8333 19.8333ZM10.8333 12H13.3333C13.7917 12 14.1667 11.625 14.1667 11.1667V5.83333C14.1667 5.375 13.7917 5 13.3333 5H10.8333C10.375 5 10 5.375 10 5.83333V11.1667C10 11.625 10.375 12 10.8333 12ZM15 5.83333V11.1667C15 11.625 15.375 12 15.8333 12H18.3333C18.7917 12 19.1667 11.625 19.1667 11.1667V5.83333C19.1667 5.375 18.7917 5 18.3333 5H15.8333C15.375 5 15 5.375 15 5.83333Z"
  })));
}

export default SvgSquare;